// extracted by mini-css-extract-plugin
module.exports = {"form":"ResetPassword_form__1NPsV","inputs":"ResetPassword_inputs__21n1q","root":"ResetPassword_root__29rXK","messages":"ResetPassword_messages__2XKow"};